/* eslint-disable eqeqeq */
<template>
  <div>
    <a-card>
      <a-row :gutter="20">
        <a-col :span="12">
          <div style="margin-bottom:0.5rem;margin-left:0.5rem">智能地址识别</div>
          <a-textarea
            v-model="resolution"
            placeholder="粘贴整段地址，可一键自动识别，无需手动选择"
            maxlength="100"
            :rows="4"
          ></a-textarea>
          <div style="display:flex;justify-content:flex-end">{{ resolution.length }}/100</div>
          <div style="display:flex;justify-content:flex-end">
            <a-button type="primary" @click="addressResolution">解析地址</a-button>
          </div>
          <a-form layout="inline" :form="form">
            <div style="margin:0.5rem">选择地址</div>
            <a-form-item label>
              <a-select
                placeholder="选择省份"
                style="width: 120px"
                @change="haveProvince1"
                v-decorator="['provinceCode', { rules: [{ required: true, message: '请选择省级地区' }] }]"
                :v-model="provinceCode"
              >
                <a-select-option v-for="item in provinces" :key="item.provinceCode">{{
                  item.provinceName
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select
                placeholder="选择城市"
                :v-model="cityCode"
                style="width: 120px"
                @change="haveProvince2"
                v-decorator="['cityCode', { rules: [{ required: true, message: '市' }] }]"
              >
                <a-select-option v-for="item in city" :key="item.cityCode">{{ item.cityName }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select
                placeholder="选择区/县"
                style="width: 120px"
                :v-model="areaCode"
                @change="haveProvince3"
                v-decorator="['areaCode', { rules: [{ required: false, message: '区' }] }]"
              >
                <a-select-option v-for="item in county" :key="item.areaCode">{{ item.areaName }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-input
                autocomplete="off"
                placeholder="选择乡镇/街道"
                style="width:180px;background-color:#fff"
                :v-model="villages"
                v-decorator="['villages', { rules: [{ required: false }] }]"
              ></a-input>
            </a-form-item>
          </a-form>
          <a-form :form="form">
            <a-form-item>
              <div>
                <div style="margin-top:1rem">选择服务类目</div>
                <a-radio-group
                  @change="onChange"
                  defaultValue="SMART_SWITCH"
                  v-decorator="[
                    {
                      rules: [
                        {
                          required: true,
                          message: '请选择服务类目!'
                        }
                      ]
                    }
                  ]"
                >
                  <a-radio-button :defaultChecked="true" value="SMART_SWITCH">智能锁</a-radio-button>
                </a-radio-group>
              </div>
            </a-form-item>
          </a-form>
          <div style="margin-top:3rem; display:flex;justify-content:center">
            <a-button type="primary" style="margin-right:1.5rem" @click="query">查询</a-button>
            <a-button type="primary" @click="reset">重置</a-button>
          </div>
        </a-col>
        <a-col :span="12" style="text-align: center;">
          <div id="mapChart" class="chart" style="width:100%;height:32rem;"></div>
          <div v-if="masterNumber >= 0" style="margin-top:-30px;">
            <!-- <div style="margin-bottom:1rem;font-size:1rem">{{ area }}</div> -->
            <div style="margin-bottom:1rem;font-size:1.5rem">
              共有师傅
              <span style="color:#4692ff">{{ masterNumber }}</span>
              位
            </div>
            <div style="color:#b3afac;margin-bottom:1rem">本次查询结果仅供参考，具体以实际服务情况为准</div>
            <a-button type="primary" style="width:10rem" @click="goNewlyaddedOrderList">立即下单</a-button>
          </div>
          <newlyadded-order-list-model ref="newlyaddedorderlist"></newlyadded-order-list-model>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import { getSelectAllProvince, getelectCityName, getelectAreaName } from '@/api/master/MasterListEdit'
import { getanalysisText } from '@/api/order/NewlyaddedOrderList'
import NewlyaddedOrderListModel from '../order/modules/NewlyaddedOrderListModel'
import { countMasterForEnterpriseMerchants } from '@/api/order/orderList'
import cityMap from '@/assets/map/js/china-main-city-map.js'
// 中国地图（第一级地图）的ID、Name、Json数据
var chinaId = 100000
var chinaName = 'china'
var title = ''

// Echarts地图全局变量，主要是在返回上级地图的方法中会用到
var myChart = null
var data = [
  // { name: '北京', value: 199 },
  // { name: '台湾', value: 199 },
  // { name: '天津', value: 42 },
  // { name: '河北', value: 102 },
  // { name: '山西', value: 81 },
  // { name: '内蒙古', value: 47 },
  // { name: '辽宁', value: 67 },
  // { name: '吉林', value: 82 },
  // { name: '黑龙江', value: 1233 }
  // { name: '上海', value: 24 },
  // { name: '江苏', value: 92 },
  // { name: '浙江', value: 114 }
  // { name: '安徽', value: 109 },
  // { name: '福建', value: 116 },
  // { name: '江西', value: 91 },
  // { name: '山东', value: 119 },
  // { name: '河南', value: 137 },
  // { name: '湖北', value: 116 },
  // { name: '湖南', value: 114 },
  // { name: '重庆', value: 91 },
  // { name: '四川', value: 125 },
  // { name: '贵州', value: 62 },
  // { name: '云南', value: 83 },
  // { name: '西藏', value: 9 },
  // { name: '陕西', value: 80 },
  // { name: '甘肃', value: 56 },
  // { name: '青海', value: 10 },
  // { name: '宁夏', value: 18 }
  // { name: '新疆', value: 10 },
  // { name: '广东', value: 123 },
  // { name: '广西', value: 59 },
  // { name: '海南', value: 14 }
]
var geoCoordMap = {
  台湾: [121.5135, 25.0308],
  黑龙江省: [127.9688, 45.368],
  内蒙古自治区: [110.3467, 41.4899],
  吉林省: [125.8154, 44.2584],
  北京市: [116.4551, 40.2539],
  辽宁省: [123.1238, 42.1216],
  河北省: [114.4995, 38.1006],
  天津市: [117.4219, 39.4189],
  山西省: [112.3352, 37.9413],
  陕西省: [109.1162, 34.2004],
  甘肃省: [103.5901, 36.3043],
  宁夏回族自治区: [106.3586, 38.1775],
  青海省: [101.4038, 36.8207],
  新疆维吾尔自治区: [87.9236, 43.5883],
  西藏自治区: [91.11, 29.97],
  四川省: [103.9526, 30.7617],
  重庆市: [108.384366, 30.439702],
  山东省: [117.1582, 36.8701],
  河南省: [113.4668, 34.6234],
  江苏省: [118.8062, 31.9208],
  安徽省: [117.29, 32.0581],
  湖北省: [114.3896, 30.6628],
  浙江省: [119.5313, 29.8773],
  福建省: [119.4543, 25.9222],
  江西省: [116.0046, 28.6633],
  湖南省: [113.0823, 28.2568],
  贵州省: [106.6992, 26.7682],
  云南省: [102.9199, 25.4663],
  广东省: [113.12244, 23.009505],
  广西壮族自治区: [108.479, 23.1152],
  海南省: [110.3893, 19.8516],
  上海市: [121.4648, 31.2891],
  香港特别行政区: [114.15, 22.15],
  澳门特别行政区: [113.549, 22.199]
}
var convertData = function(data) {
  var res = []
  for (var i = 0; i < data.length; i++) {
    var geoCoord = geoCoordMap[data[i].name]
    if (geoCoord) {
      res.push({
        name: data[i].name,
        value: geoCoord.concat(data[i].value)
      })
    }
  }
  return res
}

export default {
  components: {
    NewlyaddedOrderListModel
  },
  data() {
    return {
      resolution: '', // 地址解析
      dataAll: {}, // 地址解析获取值
      provinces: [], // 省份
      provinceCode: '',
      city: [], // 城市
      cityCode: '',
      county: [], // 县
      areaCode: '', // 县、区
      villages: '', // 乡镇
      form: this.$form.createForm(this),
      lock: 'SMART_SWITCH', // 智能锁
      masterNumber: -1,
      area: null, // 右边的区域名
      mapJson: ''
    }
  },
  created() {
    getSelectAllProvince().then(res => {
      this.provinces = res.rows
    })
  },
  mounted() {
    this.mapChart('mapChart')
    window.onresize = () => {
      myChart.resize()
    }
  },
  methods: {
    /**
     * Echarts地图
     */
    mapChart(divid) {
      axios.get('/static/json/map/' + chinaId + '.json', {}).then(response => {
        this.mapJson = response.data
        myChart = this.$echarts.init(document.getElementById(divid))
        this.registerAndsetOption(myChart, chinaId, chinaName, this.mapJson)
        // myChart.on('click', function(param) {
        //   console.log(param)
        // })
      })
    },
    /**
     *
     * @param {*} myChart
     * @param {*} id        省市县Id
     * @param {*} name      省市县名称
     * @param {*} mapJson   地图Json数据
     */
    registerAndsetOption(myChart, id, name, mapJson) {
      this.$echarts.registerMap(name, mapJson)
      myChart.setOption({
        // backgroundColor: {
        //   type: 'linear',
        //   x: 0,
        //   y: 0,
        //   x2: 1,
        //   y2: 1,
        //   colorStops: [
        //     {
        //       offset: 0,
        //       color: '#0f378f' // 0% 处的颜色
        //     },
        //     {
        //       offset: 1,
        //       color: '#00091a' // 100% 处的颜色
        //     }
        //   ],
        //   globalCoord: false // 缺省为 false
        // },
        title: {
          top: 20,
          text: title,
          subtext: '',
          x: 'center',
          textStyle: {
            color: '#333'
          }
        },
        geo: {
          map: 'china',
          show: true,
          roam: false,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#3a7fd5',
              borderColor: '#99ccff', // 线
              shadowColor: '#092f8f', // 外发光
              shadowBlur: 0
            },
            emphasis: {
              areaColor: '#0a2dae' // 悬浮区背景
            }
          }
        },
        series: [
          {
            type: 'map',
            map: name,
            label: {
              emphasis: {
                textStyle: {
                  color: 'black',
                  fontWeight: 'bold',
                  textBorderColor: 'white'
                }
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#7a92db',
                borderColor: 'white',
                borderWidth: 1
              },
              emphasis: {
                areaColor: '#3b488e'
              }
            },
            data: this.initMapData(mapJson)
          },
          {
            name: 'Top 5',
            type: 'scatter',
            coordinateSystem: 'geo',
            symbol: 'pin',
            symbolSize: [50, 50],
            label: {
              normal: {
                show: true,
                textStyle: {
                  color: '#fff',
                  fontSize: 12
                },
                formatter(value) {
                  return value.data.value[2]
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#FF4040' // 标志颜色
              }
            },
            data: convertData(data),
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            zlevel: 1
          }
        ]
      })
    },

    initMapData(mapJson) {
      var mapData = []
      for (var i = 0; i < mapJson.features.length; i++) {
        mapData.push({
          name: mapJson.features[i].properties.name
          // id:mapJson.features[i].id
        })
      }
      return mapData
    },
    // 省
    haveProvince1(e) {
      this.city = []
      this.county = []
      this.form.resetFields('cityCode')
      this.form.resetFields('areaCode')
      // this.form.setFieldsValue({
      //   serviceCityId: undefined,
      //   serviceDistrictId: undefined
      // })
      getelectCityName({ provinceCode: e }).then(res => {
        // console.log(res)
        this.city = res.rows
      })
      this.provinceCode = e
    },
    // 市
    haveProvince2(e) {
      this.county = []
      this.form.resetFields('areaCode')
      // this.form.setFieldsValue({
      //   serviceDistrictId: undefined
      // })
      getelectAreaName({ cityCode: e }).then(res => {
        this.county = res.rows
      })
      this.cityCode = e
      this.areaCode = ''
    },
    haveProvince3(e) {
      this.areaCode = e
    },
    onChange(e) {
      console.log(`${e.target.value}`)
      this.lock = e.target.value
    }, // 选择服务类目
    async addressResolution() {
      try {
        if (this.resolution) {
          await getanalysisText(this.resolution).then(res => {
            this.dataAll = res.data
            this.provinceCode = res.data.provinceCode
            this.form.setFieldsValue({ provinceCode: this.provinceCode })
            getelectCityName({ provinceCode: this.dataAll.provinceCode })
              .then(res => {
                if (res.code === 0) {
                  console.log('1', res)
                  this.city = res.rows
                } else {
                  this.$message.error(res.msg)
                }
              })
              .then(res => {
                for (const item of this.city) {
                  if (item.cityName == this.dataAll.cityName) {
                    this.dataAll.cityCode = item.cityCode
                    this.cityCode = item.cityCode
                  }
                }
                getelectAreaName({ cityCode: this.dataAll.cityCode })
                  .then(res => {
                    if (res.code === 0) {
                      console.log('2', res)
                      this.county = res.rows
                      for (const item of this.county) {
                        // console.log(item.areaName, this.dataAll.areaName)
                        if (item.areaName == this.dataAll.areaName) {
                          this.dataAll.areaCode = item.areaCode
                          this.areaCode = item.areaCode
                        }
                      }
                    } else {
                      this.$message.error(res.msg)
                    }
                  })
                  .then(res => {
                    this.$nextTick(() => {
                      this.form.setFieldsValue({
                        provinceCode: this.dataAll.provinceCode,
                        cityCode: this.dataAll.cityCode,
                        areaCode: this.dataAll.areaCode
                      })
                      this.form.setFieldsValue({
                        villages: this.dataAll.town + this.dataAll.clientAddress
                      })
                    })
                  })
              })
          })
        } else {
          this.$message.error('请输入需要解析的内容')
        }
      } catch (err) {
        console.log(err)
      }
    }, // 地址解析接口
    goNewlyaddedOrderList() {
      // this.$refs.newlyaddedorderlist.showNewlyaddedOrderList()
      this.$router.push({
        name: 'qyCreateOrder'
      })
    }, // 下单弹层
    query() {
      // myChart.dispatchAction({
      //   type: 'highlight',
      //   seriesIndex: 0,
      //   dataIndex: 1
      // })
      // myChart.dispatchAction({
      //   type: 'showTip',
      //   seriesIndex: 0,
      //   dataIndex: 1
      // })
      this.form.validateFields((err, values) => {
        if (!err) {
          countMasterForEnterpriseMerchants({
            installType: this.lock,
            provinceId: this.provinceCode,
            cityId: this.cityCode,
            districtId: this.areaCode
          }).then(res => {
            this.masterNumber = res.data.number
            this.area = res.data.area

            this.provinces.forEach(item => {
              if (item.provinceCode == this.provinceCode) {
                console.log(item.provinceName)
                data = [{ name: item.provinceName, value: this.masterNumber }]
                title = this.area
                this.registerAndsetOption(myChart, chinaId, chinaName, this.mapJson)
              }
            })
          })
        }
      })
    }, // 查询
    reset() {
      this.resolution = '' // 地址解析
      this.villages = '' // 乡镇
      this.form.resetFields()
      this.masterNumber = -1
    } // 重置
  }
}
</script>
<style scoped lang="less">
.map {
  position: relative;
  height: 36rem;
  background: url(../../assets/masterquery-1.png) no-repeat 0 0;
  padding-bottom: 20rem;
  background-size: 100% 140%;
  .img1 {
    position: absolute;
    top: 33%;
    left: 79%;
  }
  .img2 {
    position: absolute;
    top: 45%;
    left: 80%;
  }
  .img3 {
    position: absolute;
    top: 60%;
    left: 60%;
  }
  .img4 {
    position: absolute;
    top: 56%;
    left: 74%;
  }
  .img5 {
    position: absolute;
    top: 70%;
    left: 65%;
  }
}
</style>
